import { mapValues, templateSettings } from 'lodash';
import mustache from 'mustache';

import {
  JSONObject,
  JSONValue,
  isJSONObject,
} from 'src/app/graph/explorerPage/helpers/types';

templateSettings.interpolate = /{{([\s\S]+?)}}/g;

export function traverseVariablesAndAttemptInterpolation(
  variables: JSONObject,
  environmentVariables: JSONObject,
): JSONObject {
  function handleValue(value: JSONValue): JSONValue {
    if (typeof value === 'string') {
      try {
        return mustache.render(value, environmentVariables);
      } catch (err) {
        return value;
      }
    } else if (Array.isArray(value)) {
      return value.map(handleValue);
    } else if (isJSONObject(value)) {
      return mapValues(value, handleValue);
    } else {
      return value;
    }
  }

  return mapValues(variables, handleValue);
}
